import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const Footer = () => {
  const { winners } = useSelector((store) => store.board);
  const [winnersList, setWinnersList] = useState([winners]);

  useEffect(() => {
    const num = winners.length;
    const emptyWinners = Array(10 - num).fill({
      name: "Unknown",
      moves: 0,
      datetime: "",
    });
    setWinnersList([...winners, ...emptyWinners]);
  }, [winners]);

  return (
    <div className="footer">
      <h4>TOP 10 PLAYERS:</h4>
      <table>
        <tr>
          <th>Rank</th>
          <th>Name</th>
          <th>Moves</th>
          <th>Time</th>
        </tr>
        {winnersList.map((player, i) => (
          <tr>
            <td>{i + 1}.</td>
            <td>{player.name}</td>
            <td>{player.moves}</td>
            <td>{player.datetime}</td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default Footer;
